'use client';

import { useEffect, useState } from 'react';
import { OrderPagesURL } from '@/app/(order)/types';
import { AppNextLink } from '../app-next-link';
import { Modal } from '../modal';
import { CustomEventType } from '../types';
const AppCartLimitModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    document.addEventListener(CustomEventType.CartLimit, () => {
      setIsOpen(true);
    });
    return () => {
      document.addEventListener(CustomEventType.CartLimit, () => {
        setIsOpen(false);
      });
    };
  }, []);
  return <Modal handleClose={handleClose} title='تکمیل ظرفیت سبد خرید' width='w-full lg:w-[508px]' className='bottom-0 h-fit' isOpen={isOpen} data-sentry-element="Modal" data-sentry-component="AppCartLimitModal" data-sentry-source-file="app-cart-limit-modal.tsx">
            <div className='flex flex-col gap-6 p-4'>
                <p className='text-sm text-zinc-600'>
                    شما بیش از این نمی‌توانید کالایی به سبد خرید خود اضافه کنید. لطفا سفارش فعلی خود را پرداخت و مابقی
                    کالاها را در سفارش بعدی ثبت کنید.
                </p>

                <AppNextLink href={OrderPagesURL.CART} prefetch={false} className='mx-auto p-2 text-brand-primary' data-sentry-element="AppNextLink" data-sentry-source-file="app-cart-limit-modal.tsx">
                    مشاهده سبد خرید
                </AppNextLink>
            </div>
        </Modal>;
};
export default AppCartLimitModal;